import { useMemo } from 'react';
import { useAllUsers } from 'src/modules/shared/hooks/api/admin/users';
import { createQuery } from 'src/modules/shared/utils/api/query-builder.util';

/**
 * Communications needs to include system users (AI employees) to:
 * - show correct attribution in interactions/conversations
 * - allow filtering/assignment to AI employees when enabled for the user
 *
 * All other areas of the app should continue defaulting to person-only users.
 */
export function useAllPersonAndSystemUsers() {
  const filterBy = useMemo(
    () => createQuery().equals('kind', ['person', 'system']).build().filterBy,
    []
  );

  return useAllUsers({ filterBy });
}
